const Profiledata = [
  {
    id: 1,
    cat: "technology",
    pera: "connect with real life domain expert & get high quality mentoring & guidance for a great career.",
    image: "/images/sohit.png",
    name: "Sohit Pathak",
    job: "M.TECH (IIT Madras)",
    domain: "Machine learning, Python & Higher Mathematics",
    company: "",
    about:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet placerat ipsum. Sed posuere felis vel dolor feugiat, sit amet aliquet sapien luctus. Donec vulputate ultrices porttitor. Mauris in neque euismod, vestibulum lacus ac, vehicula ipsum. Quisque molestie tempor consectetur. Sed purus velit, vulputate ut pellentesque eget, varius blandit neque. Nulla id lectus vitae diam posuere venenatis eu sit amet nisi. Integer at leo vel nibh vulputate elementum. Ut aliquet, magna eu tempor elementum, arcu neque dapibus nisi, sed interdum quam lorem ut metus. Nunc leo leo, tristique nec ullamcorper nec, porta eget arcu. Aliquam erat volutpat. Maecenas leo mi, pulvinar non lectus ut, lobortis eleifend leo.",
    education: "Lorem ipsum dolor sit amet",
    skills: [
      {
        skill: "skill1",
      },
      {
        skill: "skill2",
      },
      {
        skill: "skill3",
      },
      {
        skill: "skill4",
      },
      {
        skill: "skill5",
      },
      {
        skill: "skill6",
      },
    ],
    contact: "xxxxx xxxxx",
    email: "emailid@email.com",
    experience: [
      {
        title: "company/organisation name",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet placerat ipsum. Sed posuere felis vel dolor feugiat, sit amet aliquet sapien luctus.",
      },
      {
        title: "company/organisation name",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet placerat ipsum. Sed posuere felis vel dolor feugiat, sit amet aliquet sapien luctus.",
      },
    ],
  },
  {
    id: 2,
    cat: "Product",
    pera: "connect with real life domain expert & get high quality mentoring & guidance for a great career.",
    image: "/images/ashish.png",
    name: "Ashish Kumar",
    job: "Officer (Fire & Safety)",
    domain: "",
    company: "Company - GACL",
    about:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet placerat ipsum. Sed posuere felis vel dolor feugiat, sit amet aliquet sapien luctus. Donec vulputate ultrices porttitor. Mauris in neque euismod, vestibulum lacus ac, vehicula ipsum. Quisque molestie tempor consectetur. Sed purus velit, vulputate ut pellentesque eget, varius blandit neque. Nulla id lectus vitae diam posuere venenatis eu sit amet nisi. Integer at leo vel nibh vulputate elementum. Ut aliquet, magna eu tempor elementum, arcu neque dapibus nisi, sed interdum quam lorem ut metus. Nunc leo leo, tristique nec ullamcorper nec, porta eget arcu. Aliquam erat volutpat. Maecenas leo mi, pulvinar non lectus ut, lobortis eleifend leo.",
    education: "Lorem ipsum dolor sit amet",
    skills: [
      {
        skill: "skill1",
      },
      {
        skill: "skill2",
      },
      {
        skill: "skill3",
      },
      {
        skill: "skill4",
      },
      {
        skill: "skill5",
      },
      {
        skill: "skill6",
      },
    ],
    contact: "xxxxx xxxxx",
    email: "emailid@email.com",
    experience: [
      {
        title: "company/organisation name",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet placerat ipsum. Sed posuere felis vel dolor feugiat, sit amet aliquet sapien luctus.",
      },
      {
        title: "company/organisation name",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet placerat ipsum. Sed posuere felis vel dolor feugiat, sit amet aliquet sapien luctus.",
      },
    ],
  },
  {
    id: 3,
    cat: "technology",
    pera: "connect with real life domain expert & get high quality mentoring & guidance for a great career.",
    image: "/images/dinesh.png",
    name: "Dinesh Kumar",
    job: "Research Scholar",
    domain: "Differential Equation, Linear Algebra, NET-JRF, GATE(MA)",
    about:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet placerat ipsum. Sed posuere felis vel dolor feugiat, sit amet aliquet sapien luctus. Donec vulputate ultrices porttitor. Mauris in neque euismod, vestibulum lacus ac, vehicula ipsum. Quisque molestie tempor consectetur. Sed purus velit, vulputate ut pellentesque eget, varius blandit neque. Nulla id lectus vitae diam posuere venenatis eu sit amet nisi. Integer at leo vel nibh vulputate elementum. Ut aliquet, magna eu tempor elementum, arcu neque dapibus nisi, sed interdum quam lorem ut metus. Nunc leo leo, tristique nec ullamcorper nec, porta eget arcu. Aliquam erat volutpat. Maecenas leo mi, pulvinar non lectus ut, lobortis eleifend leo.",
    education: "Lorem ipsum dolor sit amet",
    skills: [
      {
        skill: "skill1",
      },
      {
        skill: "skill2",
      },
      {
        skill: "skill3",
      },
      {
        skill: "skill4",
      },
      {
        skill: "skill5",
      },
      {
        skill: "skill6",
      },
      {
        skill: "skill7",
      },
      {
        skill: "skill8",
      },
    ],
    contact: "xxxxx xxxxx",
    email: "emailid@email.com",
    experience: [
      {
        title: "company/organisation name",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet placerat ipsum. Sed posuere felis vel dolor feugiat, sit amet aliquet sapien luctus.",
      },
      {
        title: "company/organisation name",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet placerat ipsum. Sed posuere felis vel dolor feugiat, sit amet aliquet sapien luctus.",
      },
    ],
  },
  {
    id: 4,
    cat: "banking",
    pera: "connect with real life domain expert & get high quality mentoring & guidance for a great career.",
    image: "/images/chinese.png",
    name: "Shivani Saini",
    job: "Relationship Officer",
    domain: "Banking Industry",
    company: "ICICI Bank",
    about:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet placerat ipsum. Sed posuere felis vel dolor feugiat, sit amet aliquet sapien luctus. Donec vulputate ultrices porttitor. Mauris in neque euismod, vestibulum lacus ac, vehicula ipsum. Quisque molestie tempor consectetur. Sed purus velit, vulputate ut pellentesque eget, varius blandit neque. Nulla id lectus vitae diam posuere venenatis eu sit amet nisi. Integer at leo vel nibh vulputate elementum. Ut aliquet, magna eu tempor elementum, arcu neque dapibus nisi, sed interdum quam lorem ut metus. Nunc leo leo, tristique nec ullamcorper nec, porta eget arcu. Aliquam erat volutpat. Maecenas leo mi, pulvinar non lectus ut, lobortis eleifend leo.",
    education: "Lorem ipsum dolor sit amet",
    skills: [
      {
        skill:"skill1",
      },
      {
        skill:"skill2",
      },
      {
        skill:"skill3",
      },
      {
        skill:"skill4",
      },
    ],
    contact: "xxxxx xxxxx",
    email: "emailid@email.com",
    experience: [
      {
        title: "company/organisation name",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet placerat ipsum. Sed posuere felis vel dolor feugiat, sit amet aliquet sapien luctus.",
      },
      {
        title: "company/organisation name",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sit amet placerat ipsum. Sed posuere felis vel dolor feugiat, sit amet aliquet sapien luctus.",
      },
    ],
  },
];

export default Profiledata;
